document.addEventListener("DOMContentLoaded", function () {
  if (typeof Shopify === "undefined" || Shopify.designMode) return;

  var ua = window.navigator.userAgent;

  if (/Chrome-Lighthouse/i.test(ua)) return;

  var isMobile = /mobi/i.test(ua);

  var style = document.createElement("style");
  style.setAttribute("data-content-protect", "");
  style.appendChild(
    document.createTextNode(
      "body{-webkit-touch-callout:none;-webkit-user-select:none;" +
        "-moz-user-select:none;-ms-user-select:none;user-select:none;}" +
        "img{-webkit-user-drag:none;user-drag:none;-webkit-touch-callout:none;}" +
        "@media print{body{display:none !important;visibility:hidden !important;}}"
    )
  );
  document.head.appendChild(style);

  function tagOf(e) {
    return ((e.target || e.srcElement).tagName || "").toLowerCase();
  }
  function isField(tag) {
    return tag === "input" || tag === "textarea";
  }

  document.addEventListener("contextmenu", function (e) {
    if (!isField(tagOf(e))) e.preventDefault();
  });

  document.addEventListener("copy", function (e) {
    if (!isField(tagOf(e))) e.preventDefault();
  });
  document.addEventListener("cut", function (e) {
    if (!isField(tagOf(e))) e.preventDefault();
  });

  document.addEventListener("dragstart", function (e) {
    if (tagOf(e) === "img") e.preventDefault();
  });

  if (!isMobile) {
    document.addEventListener("keydown", function (e) {
      var k = e.keyCode;
      if (
        k === 123 ||
        (e.ctrlKey && e.shiftKey && (k === 73 || k === 74 || k === 67)) ||
        (e.ctrlKey && (k === 85 || k === 83 || k === 80))
      ) {
        e.preventDefault();
        return false;
      }
    });
  }

  try {
    console.log(
      "%cLEGAL NOTICE",
      "color:red;font-size:1.4rem;font-weight:700;"
    );
    console.log(
      "%cThis website and its content are copyright. All rights reserved.",
      "color:#000;font-size:1rem;"
    );
  } catch (e) {}
});
